import PropTypes from 'prop-types'
import React from 'react'
import styles from './_friendGlobal.css'
import Button from 'components/util/Button'
import { FormattedMessage } from 'react-intl'
import Loader from 'components/util/Loader'

export function FriendRequest ({ friendInfo, idInLoadingState, acceptAction, denyAction }) {
  const basicUserInfo = {
    displayName: friendInfo.display_name,
    id: friendInfo.id,
  }

  const profile = `/profile/${basicUserInfo.id}`
  const profileImage = `${profile}/picture?size=Medium`
  const loadingState = friendInfo.id === idInLoadingState

  return (
    <div className={styles.friendContainer}>
      <div className={styles.friendInner}>
        <a href={profile}>
          <img className={styles.profileImage} src={profileImage} />
        </a>
        <div className={styles.friendName}>
          <a href={profile}>{basicUserInfo.displayName}</a>
        </div>
        <div
          className={styles.friendRequestButtonContainer}>
          {!loadingState ?
            <div>
              <Button
                size='small'
                className={styles.denyButton}
                type='secondary'
                el='button'
                onClick={() => denyAction(basicUserInfo, true)}>
                <FormattedMessage
                  id='friendrequest.deny'
                  defaultMessage='Deny'
                />
              </Button>
              <Button
                size='small'
                type='action'
                el='button'
                onClick={() => acceptAction(friendInfo)}>
                <FormattedMessage
                  id='friendrequest.accept'
                  defaultMessage='Accept'
                 />
              </Button>
            </div> : <Loader type='spin' height={25} width={25} />}
        </div>
      </div>
    </div>
  )
}

FriendRequest.propTypes = {
  friendInfo: PropTypes.object,
  acceptAction: PropTypes.func,
  denyAction: PropTypes.func,
  idInLoadingState: PropTypes.number,
}

export default FriendRequest
